import { BlocksGalleryType, GalleryBlock } from '../galleryBlock/GalleryBlock';
import { BlocksMediaType, MediaBlock } from '../mediaBlock/MediaBlock';
import { BlocksGridType, GridBlock } from '../gridBlock/GridBlock';
import { BlockQuoteType, QuoteBlock } from '../quoteBlock/QuoteBlock';
import { BlocksTextType, TextBlock } from '../textBlock/TextBlock';
import { BlocksMixedType, MixedBlock } from '../mixedBlock/MixedBlock';
import { BlocksStatsType, StatsBlock } from '../statsBlock/StatsBlock';

export type DefaultMediaBlockProps = {
  image_height: number;
  image_width: number;
  image: string;
  phone_image_height?: number;
  phone_image_width?: number;
  phone_image?: string;
  video?: string;
  phone_video?: string;
  alt_text: string;
  autoplay?: boolean;
  controls?: boolean;
  loop?: boolean;
  text?: string;
  caption?: string;

  orientation?: {
    image: 'landscape' | 'portrait' | 'square';
    phone_image?: 'landscape' | 'portrait' | 'square';
  };
};
export type DefaultBlockProps = {
  size?: 'full' | 'large' | 'medium' | 'half' | undefined;
  position?: 'left' | 'right' | undefined;
  media: DefaultMediaBlockProps | DefaultMediaBlockProps[];
};

export type BlockType =
  | BlocksMediaType
  | BlocksTextType
  | BlocksGalleryType
  | BlocksGridType
  | BlockQuoteType
  | BlocksMixedType
  | BlocksStatsType;

export type Props = { block: BlockType; sizes?: string };

export const SwitchBlock = ({ block, sizes }: Props): JSX.Element => {
  switch (block.block_type) {
    // image and or video
    case 'media':
      return <MediaBlock {...block} layout="responsive" sizes={sizes} />;
    case 'text':
      return <TextBlock {...block} />;
    case 'gallery':
      return <GalleryBlock {...block} />;
    case 'quote':
      return <QuoteBlock {...block} />;
    case 'mixed':
      return <MixedBlock {...block} />;
    case 'grid':
      return <GridBlock {...block} />;
    case 'stats':
      return <StatsBlock {...block} />;

    default:
      // this part of the code should be unreachable!
      console.log({ block });
      return <p>an unkown block type.</p>;
  }
};
